import { Box, Container, Paper, Typography, useTheme } from '@mui/material';
import CoffeeTablePng from 'src/assets/png/coffee_table.png';
import { FadeInSection } from 'src/components/FadeInSection/FadeInSection';

const AboutMe: React.FC<{ id: string }> = ({ id }) => {
  const theme = useTheme();
  return (
    <Box
      id={id}
      sx={{
        backgroundColor: theme.palette.primary.light,
        boxShadow: `0px 0px 20px ${theme.palette.primary.light}`,
      }}
    >
      <Container
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          textAlign: 'center',
          justifyContent: 'center',
          gap: '32px',
          padding: '64px 10vw',
        }}
      >
        <FadeInSection>
          <Typography
            variant='h6'
            sx={{
              color: theme.extendedPalette.accent.main,
            }}
          >
            About Me
          </Typography>
        </FadeInSection>
        <FadeInSection>
          <Paper
            sx={{
              height: '200px',
              width: '250px',
              backgroundImage: `url(${CoffeeTablePng})`,
              backgroundRepeat: 'no-repeat',
              backgroundPosition: '80% 50%',
              backgroundSize: 'cover',
            }}
          ></Paper>
        </FadeInSection>
        {/* <Typography variant='h5'>
          A dedicated Full-Stack Developer based in USA, California
        </Typography> */}
        <FadeInSection>
          <Typography variant='body1'>
            As a software engineer, I possess an impressive arsenal of skills in
            HTML, CSS, JavaScript, React, SCSS, and Python. I excel in designing
            and maintaining responsive websites that offer a smooth user
            experience. My expertise lies in crafting dynamic, engaging
            interfaces through writing clean and optimized code and utilizing
            cutting-edge development tools and techniques. I am also a team
            player who thrives in collaborating with cross-functional teams to
            produce outstanding web applications.
          </Typography>
        </FadeInSection>
      </Container>
    </Box>
  );
};
export default AboutMe;
